import React, { useState } from "react";

interface DragDotsProps {
    color?: string;
    className?: string;
    onClick?: () => void;
    size?: number | string;
}

const DragDots: React.FC<DragDotsProps> = ({
    onClick,
    size = 24,
    className,
    color = "#F7F9F9",
}) => {
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const style = size ? { width: size, height: size } : undefined;
    
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <path
                d="M6.66683 10.8333C7.12707 10.8333 7.50016 10.4602 7.50016 10C7.50016 9.53977 7.12707 9.16668 6.66683 9.16668C6.20659 9.16668 5.8335 9.53977 5.8335 10C5.8335 10.4602 6.20659 10.8333 6.66683 10.8333Z"
                fill="#F7F9F9"
            />
            <path
                d="M6.66683 5.00001C7.12707 5.00001 7.50016 4.62691 7.50016 4.16668C7.50016 3.70644 7.12707 3.33334 6.66683 3.33334C6.20659 3.33334 5.8335 3.70644 5.8335 4.16668C5.8335 4.62691 6.20659 5.00001 6.66683 5.00001Z"
                fill="#F7F9F9"
            />
            <path
                d="M6.66683 16.6667C7.12707 16.6667 7.50016 16.2936 7.50016 15.8333C7.50016 15.3731 7.12707 15 6.66683 15C6.20659 15 5.8335 15.3731 5.8335 15.8333C5.8335 16.2936 6.20659 16.6667 6.66683 16.6667Z"
                fill="#F7F9F9"
            />
            <path
                d="M6.66683 10.8333C7.12707 10.8333 7.50016 10.4602 7.50016 10C7.50016 9.53977 7.12707 9.16668 6.66683 9.16668C6.20659 9.16668 5.8335 9.53977 5.8335 10C5.8335 10.4602 6.20659 10.8333 6.66683 10.8333Z"
                stroke={isHovered ? "#0094BD" : color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.66683 5.00001C7.12707 5.00001 7.50016 4.62691 7.50016 4.16668C7.50016 3.70644 7.12707 3.33334 6.66683 3.33334C6.20659 3.33334 5.8335 3.70644 5.8335 4.16668C5.8335 4.62691 6.20659 5.00001 6.66683 5.00001Z"
                stroke={isHovered ? "#0094BD" : color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.66683 16.6667C7.12707 16.6667 7.50016 16.2936 7.50016 15.8333C7.50016 15.3731 7.12707 15 6.66683 15C6.20659 15 5.8335 15.3731 5.8335 15.8333C5.8335 16.2936 6.20659 16.6667 6.66683 16.6667Z"
                stroke={isHovered ? "#0094BD" : color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3333 10.8333C13.7936 10.8333 14.1667 10.4602 14.1667 10C14.1667 9.53977 13.7936 9.16668 13.3333 9.16668C12.8731 9.16668 12.5 9.53977 12.5 10C12.5 10.4602 12.8731 10.8333 13.3333 10.8333Z"
                fill="#F7F9F9"
            />
            <path
                d="M13.3333 5.00001C13.7936 5.00001 14.1667 4.62691 14.1667 4.16668C14.1667 3.70644 13.7936 3.33334 13.3333 3.33334C12.8731 3.33334 12.5 3.70644 12.5 4.16668C12.5 4.62691 12.8731 5.00001 13.3333 5.00001Z"
                fill="#F7F9F9"
            />
            <path
                d="M13.3333 16.6667C13.7936 16.6667 14.1667 16.2936 14.1667 15.8333C14.1667 15.3731 13.7936 15 13.3333 15C12.8731 15 12.5 15.3731 12.5 15.8333C12.5 16.2936 12.8731 16.6667 13.3333 16.6667Z"
                fill="#F7F9F9"
            />
            <path
                d="M13.3333 10.8333C13.7936 10.8333 14.1667 10.4602 14.1667 10C14.1667 9.53977 13.7936 9.16668 13.3333 9.16668C12.8731 9.16668 12.5 9.53977 12.5 10C12.5 10.4602 12.8731 10.8333 13.3333 10.8333Z"
                stroke={isHovered ? "#0094BD" : color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3333 5.00001C13.7936 5.00001 14.1667 4.62691 14.1667 4.16668C14.1667 3.70644 13.7936 3.33334 13.3333 3.33334C12.8731 3.33334 12.5 3.70644 12.5 4.16668C12.5 4.62691 12.8731 5.00001 13.3333 5.00001Z"
                stroke={isHovered ? "#0094BD" : color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3333 16.6667C13.7936 16.6667 14.1667 16.2936 14.1667 15.8333C14.1667 15.3731 13.7936 15 13.3333 15C12.8731 15 12.5 15.3731 12.5 15.8333C12.5 16.2936 12.8731 16.6667 13.3333 16.6667Z"
                stroke={isHovered ? "#0094BD" : color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DragDots;
